// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../assets/css/colors';

const LoadingSpinnerStyled = styled.div`
	margin: ${({ margin }) => margin || '1em auto'};
	width: ${({ width }) => width || '100px'};
	height: ${({ height }) => height || '40px'};
	text-align: center;
	font-size: 10px;
	
	> div {
		background-color: ${({ color }) => color || colors.nrlDarkGreen};
		height: 100%;
		width: 6px;
		display: inline-block;
		margin: 0 3px;
		
		-webkit-animation: sk-stretchdelay 0.7s infinite ease-in-out;
		animation: sk-stretchdelay 0.7s infinite ease-in-out;
	}
	
	.rect2 {
		-webkit-animation-delay: -0.6s;
		animation-delay: -0.6s;
	}
	
	.rect3 {
		-webkit-animation-delay: -0.5s;
		animation-delay: -0.5s;
	}
	
	.rect4 {
		-webkit-animation-delay: -0.4s;
		animation-delay: -0.4s;
	}
	
	.rect5 {
		-webkit-animation-delay: -0.3s;
		animation-delay: -0.3s;
	}
	
	@-webkit-keyframes sk-stretchdelay {
		0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  
		20% { -webkit-transform: scaleY(1.0) }
	}
	
	@keyframes sk-stretchdelay {
		0%, 40%, 100% { 
			transform: scaleY(0.4);
			-webkit-transform: scaleY(0.4);
		}  20% { 
			transform: scaleY(1.0);
			-webkit-transform: scaleY(1.0);
		}
	}
`;
type Props = {
	color?: string,
	height?: string,
	width?: string,
	margin?: string
}

export const LoadingSpinner = ({ color, height, width, margin }: Props) => (
	<LoadingSpinnerStyled color={color} height={height} width={width} margin={margin}>
		<div className="rect1" />
		<div className="rect2" />
		<div className="rect3" />
		<div className="rect4" />
		<div className="rect5" />
	</LoadingSpinnerStyled>
);

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/index.js